const previewCards = [
  {
    eyebrow: 'Operasyon görünümü',
    title: 'Kurban Operasyon Havuzu',
    description: 'Hisse, kesim, tahsilat ve teslimat akışını aynı anda izlemek için ekran görüntüsü veya ürün turu yerleşimi.',
    icon: 'ri-knife-line',
    accent: 'accent',
  },
  {
    eyebrow: 'Finans görünümü',
    title: 'Finans Çapraz Kontrol',
    description: 'Satış, cari, havale ve açık tahsilat ilişkisini anlatacak ekran görüntüsü veya kısa video yerleşimi.',
    icon: 'ri-line-chart-line',
    accent: 'primary',
  },
  {
    eyebrow: 'Günlük işletme görünümü',
    title: 'Yem / Rasyon ve Stok Düzeni',
    description: 'Yem-bakım, süt-et ürünü ve işletme stokları için gerçek ekran görüntüsü veya video yerleşimi.',
    icon: 'ri-restaurant-2-line',
    accent: 'secondary',
  },
];

export default function ProductMediaSection() {
  return (
    <section id="urun-turu" className="py-16 md:py-24 bg-foreground-950 text-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mb-10 md:mb-12">
          <span className="inline-block px-4 py-1.5 bg-primary-500/20 text-primary-200 rounded-full text-xs font-semibold mb-4">
            Ürün turu alanı
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-4xl mb-4">
            Operasyonunuzu yöneten ekranları burada gösterin.
          </h2>
          <p className="text-foreground-300 text-base md:text-lg leading-relaxed">
            Bu geniş alanlar, final ekran görüntüleri ve YouTube ürün videoları hazır olduğunda doğrudan gerçek sistem görselleriyle doldurulmak üzere tasarlandı. Şimdilik ürünün üç kritik çalışma alanını açıkça konumlandırır.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {previewCards.map((card) => (
            <article key={card.title} className="media-frame min-h-[300px] p-6 flex flex-col justify-between">
              <div className="relative z-10">
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-6 ${card.accent === 'accent' ? 'bg-accent-500 text-foreground-950' : card.accent === 'secondary' ? 'bg-secondary-500 text-foreground-950' : 'bg-primary-500 text-background-50'}`}>
                  <i className={`${card.icon} text-2xl`}></i>
                </div>
                <p className="text-xs font-bold uppercase tracking-[0.15em] text-foreground-300">{card.eyebrow}</p>
                <h3 className="font-heading text-xl font-bold mt-2">{card.title}</h3>
                <p className="mt-3 text-sm leading-6 text-foreground-300">{card.description}</p>
              </div>
              <div className="relative z-10 mt-8 rounded-xl border border-white/10 bg-white/5 px-4 py-3 flex items-center gap-3 text-xs text-foreground-200">
                <i className="ri-image-line text-lg text-primary-200"></i>
                Ekran görüntüsü / video alanı
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
